/* GLACÉO Theme-JS — robust gegen Theme-Editor-Rerendering (shopify:section:load) */
(function(){
  // JS-Marker: Reveal-Verstecken nur, wenn JS wirklich läuft (sonst bleibt alles sichtbar)
  document.documentElement.classList.add('glaceo-js');

  function initHero(){
    const wrap = document.getElementById('hero-canvas-wrap');
    if(!wrap) return;
    const tooltip = document.getElementById('char-tooltip');
    const tooltipName = document.getElementById('tooltip-name');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sparkColors = { pia:'#E5719E', berry:'#E2554F', ellie:'#2E7C9E', rosie:'#EFA0BB', momo:'#E98AAD' };

    function jump(el){
      if(reducedMotion) return;
      const img = el.querySelector('img');
      if(!img) return;
      img.classList.remove('is-jumping'); void img.offsetWidth;
      img.classList.add('is-jumping');
    }
    function sparkle(el){
      if(reducedMotion) return;
      const r = el.getBoundingClientRect(), w = wrap.getBoundingClientRect();
      for(let i=0;i<7;i++){
        const s = document.createElement('span');
        s.className = 'sparkle';
        s.textContent = Math.random() > .5 ? '✦' : '✧';
        s.style.color = Math.random() > .35 ? (sparkColors[el.dataset.variant] || '#5AC8FA') : '#fff';
        s.style.left = (r.left - w.left + Math.random()*r.width) + 'px';
        s.style.top  = (r.top - w.top + Math.random()*r.height*0.45) + 'px';
        s.style.fontSize = (12 + Math.random()*12) + 'px';
        s.style.animationDelay = (Math.random()*0.15) + 's';
        wrap.appendChild(s);
        s.addEventListener('animationend', ()=>s.remove());
      }
    }
    function showTooltip(el){
      if(!tooltip) return;
      const r = el.getBoundingClientRect(), w = wrap.getBoundingClientRect();
      tooltipName.textContent = el.dataset.name;
      tooltip.style.left = (r.left - w.left + r.width/2) + 'px';
      tooltip.style.top  = (r.top - w.top) + 'px';
      tooltip.classList.add('show');
    }

    document.querySelectorAll('.crew-char').forEach(el=>{
      if(el.dataset.gbound) return;
      el.dataset.gbound = '1';
      el.addEventListener('pointerenter', ()=>{ showTooltip(el); jump(el); sparkle(el); });
      el.addEventListener('pointerleave', ()=>tooltip && tooltip.classList.remove('show'));
      el.addEventListener('click', ()=>{
        if(window.GLACEO_selectVariant) window.GLACEO_selectVariant(el.dataset.variant);
        jump(el); sparkle(el); showTooltip(el);
        setTimeout(()=>{
          const buybox = document.getElementById('buybox');
          if(buybox){
            buybox.scrollIntoView({ behavior:'smooth', block:'center' });
            buybox.classList.remove('flash'); void buybox.offsetWidth; buybox.classList.add('flash');
          }
          tooltip && tooltip.classList.remove('show');
        }, 480);
      });
    });
  }

  function initBuybox(){
    const I18N = window.GLACEO_I18N || {};
    const slotRow = document.getElementById('slot-row');
    const atcBtn = document.getElementById('atc-btn');
    const atcLabel = document.getElementById('atc-label');
    const variantName = document.getElementById('variant-name');
    const chips = [...document.querySelectorAll('.variant-chip')];
    const bundles = [...document.querySelectorAll('.bundle-card')];
    if(!slotRow || !atcBtn || !chips.length || !bundles.length) return;

    // Namen/Bilder kommen aus der Section (window.GLACEO_NAMES/THUMBS);
    // Fallback: alte Tier-Crew, falls eine Legacy-Seite sie noch nutzt.
    const names = window.GLACEO_NAMES || { ellie:'Ellie', pia:'Pia', berry:'Berry', rosie:'Rosie', momo:'Momo' };
    const firstKey = chips[0] ? chips[0].dataset.variant : Object.keys(names)[0];
    let qty = 2;
    let picks = [firstKey, firstKey];

    // Bildquellen: Section-Daten zuerst, sonst aus der Hero-Crew ziehen
    const thumbs = Object.assign({}, window.GLACEO_THUMBS || {});
    document.querySelectorAll('.crew-char').forEach(c => {
      const img = c.querySelector('img');
      if(img && !thumbs[c.dataset.variant]) thumbs[c.dataset.variant] = img.src;
    });
    chips.forEach(ch => {
      const img = ch.querySelector('img');
      if(img && !img.getAttribute('src') && thumbs[ch.dataset.variant]) img.src = thumbs[ch.dataset.variant];
      if(!ch.querySelector('.chip-count')){
        const b = document.createElement('span');
        b.className = 'chip-count';
        ch.appendChild(b);
      }
    });

    function label(id){ return names[id] || id; }
    function summary(){
      const count = {};
      picks.forEach(p => count[p] = (count[p]||0)+1);
      return Object.entries(count).map(([id,n]) => (n>1 ? n+'× ' : '') + label(id)).join(' + ');
    }
    function render(popLast){
      slotRow.innerHTML = '';
      picks.forEach((id, i) => {
        const s = document.createElement('span');
        s.className = 'slot' + (popLast && i === picks.length-1 ? ' pop' : '');
        if(thumbs[id]) s.innerHTML = '<img src="'+thumbs[id]+'" alt="'+label(id)+'">';
        else s.textContent = label(id)[0];
        s.title = label(id);
        slotRow.appendChild(s);
      });
      chips.forEach(ch => {
        const n = picks.filter(p => p === ch.dataset.variant).length;
        const b = ch.querySelector('.chip-count');
        if(b){ b.textContent = '×'+n; b.classList.toggle('show', n > 0); }
        ch.classList.toggle('active', n > 0);
      });
      if(variantName) variantName.textContent = summary();
    }

    window.GLACEO_selectVariant = function(id){
      picks.push(id);
      while(picks.length > qty) picks.shift();
      render(true);
    };

    chips.forEach(ch => {
      if(ch.dataset.gbound) return;
      ch.dataset.gbound = '1';
      ch.addEventListener('click', () => window.GLACEO_selectVariant(ch.dataset.variant));
    });

    function setBundle(card){
      bundles.forEach(b => {
        const on = b === card;
        b.classList.toggle('active', on);
        const dot = b.querySelector('.dot');
        if(dot) dot.style.opacity = on ? 1 : 0;
      });
      const newQty = parseInt(card.dataset.bundle, 10);
      if(newQty > qty){ while(picks.length < newQty) picks.push(picks[picks.length-1]); }
      if(newQty < qty){ picks = picks.slice(picks.length - newQty); }
      qty = newQty;
      if(atcLabel) atcLabel.innerHTML = (I18N.add_to_cart || 'In den Warenkorb') + ' · ' + ((window.GLACEO_PRICES && window.GLACEO_PRICES[card.dataset.bundle]) || '');
      render(false);
    }
    bundles.forEach(b => {
      if(b.dataset.gbound) return;
      b.dataset.gbound = '1';
      b.addEventListener('click', () => setBundle(b));
    });
    setBundle(bundles[1] || bundles[0]);

    if(!atcBtn.dataset.gbound){
      atcBtn.dataset.gbound = '1';
      atcBtn.addEventListener('click', async ()=>{
        const variantIds = window.GLACEO_VARIANTS || {};
        const count = {};
        picks.forEach(p => count[p] = (count[p]||0)+1);
        const items = Object.entries(count)
          .filter(([id]) => variantIds[id])
          .map(([id,n]) => ({ id: variantIds[id], quantity: n }));
        if(!items.length){ alert(I18N.err_unlinked || 'Produkt ist noch nicht verknüpft — bitte in der Buy-Box-Section das Produkt wählen.'); return; }
        atcBtn.disabled = true;
        atcBtn.classList.add('atc-pop');
        const prev = atcLabel.innerHTML;
        atcLabel.innerHTML = I18N.adding || 'Einen Moment …';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if(!res.ok) throw new Error('cart');
          atcBtn.classList.add('added');
          atcLabel.innerHTML = I18N.added || '✓ Liegt im Warenkorb';
          setTimeout(()=>{ window.location.href = '/cart'; }, 600);
        } catch(e) {
          atcLabel.innerHTML = prev;
          atcBtn.disabled = false;
          atcBtn.classList.remove('atc-pop');
          alert(I18N.err_failed || 'Das hat leider nicht geklappt — bitte versuch es noch einmal.');
        }
      });
    }
  }

  function initMisc(){
    // Scroll-Reveal — neue/nachgerenderte Elemente jederzeit einsammeln
    const io = new IntersectionObserver(entries=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold:0.15 });
    document.querySelectorAll('.reveal:not(.is-in)').forEach(el=>{
      if(el.dataset.gobs) return;
      el.dataset.gobs = '1';
      io.observe(el);
    });

    // Sticky-CTA
    const sticky = document.getElementById('sticky-cta');
    const buybox = document.getElementById('buybox');
    const hero = document.getElementById('hero-canvas-wrap');
    if(sticky && buybox && hero && !sticky.dataset.gbound){
      sticky.dataset.gbound = '1';
      let buyboxVisible = false, pastHero = false;
      const update = ()=> sticky.classList.toggle('show', pastHero && !buyboxVisible);
      new IntersectionObserver(es=>{ buyboxVisible = es[0].isIntersecting; update(); }).observe(buybox);
      new IntersectionObserver(es=>{ pastHero = !es[0].isIntersecting; update(); }, { threshold:0.2 }).observe(hero);
    }

    // FAQ: nur eins offen
    const faqs = [...document.querySelectorAll('#faq details')];
    faqs.forEach(d=>{
      if(d.dataset.gbound) return;
      d.dataset.gbound = '1';
      d.addEventListener('toggle', ()=>{
        if(d.open) faqs.forEach(o=>{ if(o!==d) o.open = false; });
      });
    });
  }

  function initAll(){
    try{ initHero(); }catch(e){ console.error('GLACÉO hero:', e); }
    try{ initBuybox(); }catch(e){ console.error('GLACÉO buybox:', e); }
    try{ initMisc(); }catch(e){ console.error('GLACÉO misc:', e); }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme-Editor rendert Sections dynamisch nach — neu initialisieren
  document.addEventListener('shopify:section:load', initAll);
})();
